import axios from "axios";

export default function createHoliday({ name, startDate, endDate, isActive = true }) {
  return new Promise((resolve, reject) =>
    axios
      .post("/support/api/v1/admin/business-holidays", {
        name,
        start_date: startDate,
        end_date: endDate,
        is_active: isActive,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
